/** List of available types for the project data tab */
export enum ProjectDataType {
  pointClouds = "pointClouds",
  sheets = "sheets",
  video = "video",
}
